import { render, staticRenderFns } from "./voiceOver.vue?vue&type=template&id=6c4bd046&scoped=true"
import script from "./voiceOver.vue?vue&type=script&lang=js"
export * from "./voiceOver.vue?vue&type=script&lang=js"
import style0 from "./voiceOver.vue?vue&type=style&index=0&id=6c4bd046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4bd046",
  null
  
)

export default component.exports